<!-- eslint-disable @angular-eslint/template/use-track-by-function -->
@if (premiumModules() ; as premiumModules) {
<div class="payment-form flex-col">
    <h1 class="titolo-form">{{ 'dottnet.extra.personalization' | translate }}</h1>
    <!-- INIZIO SELLER -->
    <!--inizio SELLER-->
    @if (user() && user().isSellerExtra) {
    <div class="seller-group flex-col">
        <form [formGroup]="sellerForm" (ngSubmit)="loadExtrauser()">
            <div class="carica-anagrafica flex-col flex-justify-center flex-align-center">
                <div class="input-anagrafica flex-row flex-align-center flex-justify-space-between">
                    <mat-form-field id="sfIdAnagraficaField">
                        <mat-label>{{ 'dottnet.extra.sellerFormAnagrafica' | translate }}</mat-label>
                        <input type="text" matInput color="primary" formControlName="sfIdAnagrafica" (input)="sfIdAnagraficaChanged()" />
                    </mat-form-field>
                    <button [disabled]="!enableCaricaAnagrafica" mat-button>
            {{ 'dottnet.extra.sellerFormCarica' | translate }}
          </button>
                </div>
                @if (loadedUser) {
                <div class="flex-col seller-form">
                    <mat-form-field id="sfNomeField">
                        <mat-label>{{ 'dottnet.extra.sellerFormNome' | translate }}</mat-label>
                        <input type="text" matInput readonly="true" color="primary" [formControl]="sfNome" />
                    </mat-form-field>
                    <mat-form-field id="sfCognomeField">
                        <mat-label>{{ 'dottnet.extra.sellerFormCognome' | translate }}</mat-label>
                        <input type="text" matInput readonly="true" color="primary" [formControl]="sfCognome" />
                    </mat-form-field>
                    <mat-form-field id="sfEmailField">
                        <mat-label>{{ 'dottnet.extra.sellerFormMail' | translate }}</mat-label>
                        <input type="text" matInput readonly="true" color="primary" [formControl]="sfEmail" />
                    </mat-form-field>
                    <mat-form-field id="sfPremiumField">
                        <mat-label>{{ 'dottnet.extra.sellerFormPremium' | translate }}</mat-label>
                        <input type="text" matInput readonly="true" color="primary" [formControl]="sfPremium" />
                    </mat-form-field>
                    <mat-form-field id="sfInizioAbbonamentoField">
                        <mat-label>{{ 'dottnet.extra.sellerFormDataInizio' | translate }}</mat-label>
                        <input type="text" matInput readonly="true" color="primary" [formControl]="sfInizioAbbonamento" />
                    </mat-form-field>
                    <mat-form-field id="sfFineAbbonamentoField">
                        <mat-label>{{ 'dottnet.extra.sellerFormDataFine' | translate }}</mat-label>
                        <input type="text" matInput readonly="true" color="primary" [formControl]="sfFineAbbonamento" />
                    </mat-form-field>
                </div>
                }
            </div>
        </form>
    </div>
    } @if (loadedUser) {
    <div class="disdici">
        @for (myModule of myPremiumModules; track myModule) {
        <div>
            @if (myModule.active) {
            <div>
                <div class="flex-row flex-align-base flex-justify-space-between disdici-block">
                    <div class="flex-col">
                        <h2 class="parent-module-title flex-align-center">
                            <img src="assets{{ myModule.logoPath }}" /> {{ myModule.title }}
                        </h2>
                        <p class="module-subtitle">{{ myModule.description }}</p>
                    </div>
                    <!-- Scelgo se mostrare un bottone per ogni pacchetto
                  1. se ho il pacchetto base con rinnovo automatico propongo di disdire tutto l'abbonamento
                  2. se ho un pacchetto non base, con rinnovo automatico propongo di disdire il singolo pacchetto
                  3. se ho il pacchetto base, con sconto base, quindi senza particoari sconti o omaggi, enon ho il rinnovo automatico,
                  propongo di riattivare l'abbonamento al termine del periodo
                  -->
                    @if (myModule.automaticRenewal && myModule.moduleId === 1) {
                    <button (click)="updateextra(myModule)" class="applica-button" mat-button>
            {{ 'dottnet.extra.deleteSubscriptionAll' | translate }}
          </button> } @if (myModule.automaticRenewal && myModule.moduleId > 1 && !myModule.product) {
                    <button (click)="updateextra(myModule)" class="applica-button" mat-button>
            {{ 'dottnet.extra.deleteSubscription' | translate }}
          </button> }
                    <!-- <button *ngIf="
							!myModule.automaticRenewal && myModule.moduleId === 1 && myModule.discountTypeId === 1
						" (click)="updateextra(myModule)" class="applica-button" mat-button>
                  {{ 'dottnet.extra.activateSubscription' | translate }}
                </button> -->
                    @if ( !myModule.automaticRenewal && !myModule.product) {
                    <button class="applica-button" mat-button>
            {{ 'dottnet.extra.deactivated' | translate }}
          </button> }
                </div>
            </div>
            }
        </div>
        }
    </div>
    } @if (user() && user().isSellerExtra && loadedUser && (discountTypeList())?.length > 0) {
    <div class="flex-col">
        <div class="form-coupon">
            <form [formGroup]="couponForm" (ngSubmit)="generacodicesconto()">
                <div class="genera-coupon flex-row flex-align-center flex-wrap flex-justify-center">
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>{{ 'dottnet.extra.selectCoupon' | translate }}</mat-label>
                            <mat-select (selectionChange)="couponSelected($event)" [formControl]="tipoSconto">
                                @for (codiceSconto of discountTypeList(); track codiceSconto) {
                                <mat-option [value]="codiceSconto.discountTypeId">
                                    {{ codiceSconto.discountType }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <button [disabled]="!enableCouponButton" class="applica-button" mat-button>
            {{ 'dottnet.extra.createCoupon' | translate }}
          </button>
                </div>
            </form>
        </div>
    </div>
    }
    <!-- FINE ANAGRAFICA SELLER -->
    <!-- <div  class="row" *ngIf="!campagna_attivo">  -->
    @if (premiumModules.length>0) {
    <div class="flex-col">
        <div class="form-codice-sconto">
            <form [formGroup]="codicescontoForm" (ngSubmit)="applicaSconto()">
                <div class="codice-sconto flex-row flex-align-center flex-wrap flex-justify-center">
                    <div class="form-group">
                        <mat-form-field id="codiceScontoField" class="sconto-field">
                            <mat-label>{{ 'dottnet.extra.codiceSconto' | translate }}</mat-label>
                            <input type="text" matInput color="primary" formControlName="token" (input)="tokenChanged()" />
                        </mat-form-field>
                        @if (tokenError(); as errore) { @if (tokenError(); as errore) {
                        <mat-error>
                            {{ errore.errorMessage }}
                        </mat-error>
                        } }
                    </div>
                    <button [disabled]="!enableTokenButton" class="applica-button" mat-button>
            {{ 'dottnet.extra.applicaSconto' | translate }}
          </button>
                </div>
            </form>
        </div>
    </div>
    }
    <!-- </div> -->
    @if (((user() && !user().isSellerExtra) || loadedUser) ) {
    <div class="flex-col">
        @if (premiumModules.length>0) {
        <div class="flex-col">
            @for (premiumModule of premiumModules; track premiumModule) {
            <div>
                @if ( premiumModule.moduleId === premiumModule.parentModuleId && premiumModule.moduleId > 1 ) {
                <div class="flex-col media-title module-block">
                    <h2 class="parent-module-title flex-align-center">
                        <img src="assets{{ premiumModule.logoPath }}" /> {{ premiumModule.title }}
                    </h2>
                    <p class="module-subtitle">{{ premiumModule.description }}</p>
                </div>
                } @if ( premiumModule.moduleId !== premiumModule.parentModuleId || premiumModule.moduleId === 1 ) {
                <div class="flex-row flex-justify-space-between media-module-block">
                    <div class="flex-row-50 media-title-block">
                        <div class="flex-col media-title title-block">
                            <h4 class="module-title">{{ premiumModule.title }}</h4>
                            <p class="module-subtitle">{{ premiumModule.description }}</p>
                        </div>
                    </div>
                    @if (premiumModule.selectable ) {
                    <div>
                        @if (premiumModule.price !== premiumModule.priceDiscounted) {
                        <mat-checkbox [disabled]="premiumModule.mandatory || premiumModule.activeCampaign === 2" [checked]="premiumModule.mandatory || premiumModule.activeCampaign === 2" (change)="updateData(premiumModule, $event.checked)" class="check-box"><del>{{ premiumModule.price }} {{
                'dottnet.extra.valuta' | translate }}</del> / {{ premiumModule.priceDiscounted }} {{ 'dottnet.extra.valuta' | translate }} {{ getDuration(premiumModule.subscriptionDuration, premiumModule.product) }}
                        </mat-checkbox>
                        } @if ( premiumModule.price === premiumModule.priceDiscounted && premiumModule.activeCampaign !== 2 ) {
                        <mat-checkbox [disabled]="premiumModule.mandatory" [checked]="premiumModule.mandatory" (change)="updateData(premiumModule, $event.checked)" class="check-box">{{ premiumModule.price }} {{ 'dottnet.extra.valuta' | translate }} {{ getDuration(premiumModule.subscriptionDuration, premiumModule.product) }}
                        </mat-checkbox>
                        }
                    </div>
                    }
                </div>
                }
            </div>

            }
        </div>
        }
        <!-- totale da pagare -->
        <div class="total-pay module-block">
            @if (premiumModules.length>0) {
            <div class="flex-col">
                <div class="flex-row flex-justify-space-between">
                    <div class="flex-row-50">
                        <p class="module-subtitle">{{ 'dottnet.extra.invoice' | translate }}</p>
                    </div>
                    <div>
                        <mat-checkbox (change)="setFatturaChecked()" class="check-box" />
                    </div>
                </div>
                @if (fatturaChecked) {
                <div class="flex-col flex-align-center">
                    <h4 class="dichiarazione">{{ 'dottnet.extra.invoiceDetail' | translate }}</h4>
                    <div class="flex-col dati-fattura">
                        <mat-form-field id="piva">
                            <mat-label>{{ 'dottnet.extra.invoiceVat' | translate }}</mat-label>
                            <input type="text" matInput color="primary" [formControl]="piva" required /> @if (piva.invalid) {
                            <mat-error>{{ 'dottnet.extra.Vat' | translate }} {{ 'dottnet.field.error.required' | translate }}
                            </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field id="pec" class="flex-row-100 mobile-form-field">
                            <mat-label>{{ 'dottnet.extra.invoicePec' | translate }}</mat-label>
                            <input type="text" matInput color="primary" [formControl]="pec" required /> @if (pec.invalid) {
                            <mat-error>{{ 'dottnet.extra.Pec' | translate }} {{ 'dottnet.field.error.required' | translate }}
                            </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field id="sd" class="flex-row-100 mobile-form-field">
                            <mat-label>{{ 'dottnet.extra.invoiceSd' | translate }}</mat-label>
                            <input type="text" matInput color="primary" [formControl]="sd" required /> @if (sd.invalid) {
                            <mat-error>{{ 'dottnet.extra.Sd' | translate }} {{ 'dottnet.field.error.required' | translate }}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                </div>
                }
            </div>
            } @if (premiumModules.length>0) {
            <div class="flex-col">
                <div>
                    <h2 class="text-center totale">
                        {{ 'dottnet.extra.total' | translate }} {{ totaleDaPagare }}{{ 'dottnet.extra.valuta' | translate }}
                    </h2>
                    @if (isAbbonatoPremium) {
                    <h2 class="text-center totale">
                        {{ 'dottnet.extra.finalTotal' | translate }} {{ totaleDaPagareProrate }}{{ 'dottnet.extra.valuta' | translate }} @if (isAbbonatoPremium) {
                        <h4 class="dichiarazione">
                            {{ 'dottnet.extra.finalTotalCondition' | translate }} {{ premiumfineabbonamento }}{{ 'dottnet.extra.finalTotalCondition2' | translate }} {{ totaleDaPagare }}{{ 'dottnet.extra.finalTotalCondition3' | translate }}{{ totaleDaPagareProrate }}{{ 'dottnet.extra.finalTotalCondition4'
                            | translate }}
                        </h4>
                        }
                    </h2>
                    }
                </div>
                <div>
                    <h4 class="dichiarazione">
                        <strong>{{ 'dottnet.extra.terms' | translate }}</strong> <br /> {{ 'dottnet.extra.condition' | translate }}
                        <a href="condizioni-utilizzo-extra" target="_blank">
              {{ 'dottnet.extra.condition2' | translate }}</a>
                    </h4>
                </div>
            </div>
            } @if (premiumModules.length>0) {
            <div class="flex-col">
                <div class="flex-row flex-justify-center extra-prosegui-button">
                    <button [disabled]="(piva.invalid || sd.invalid || pec.invalid) && fatturaChecked" mat-button (click)="showFormPagamento()">
            {{ 'dottnet.extra.prosegui' | translate }}
          </button>
                </div>
            </div>
            }
        </div>
        <div id="formPagamento" [hidden]="!showPayment">
            <div class="flex-col flex-align-center">
                <mat-tab-group dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start">
                    <mat-tab label="Carta">
                        <form action="/charge" method="post" id="payment-form">
                            <!-- a Stripe Element will be inserted here. -->
                            <fieldset>
                                <div class="flex-row pay-field">
                                    <label for="name" data-tid="elements_examples.form.name_label">{{ 'dottnet.extra.payment.name' |
                    translate }}*</label>
                                    <input id="name" data-tid="elements_examples.form.name_placeholder" type="text" required [formControl]="name" autocomplete="name" />
                                </div>
                                @if (name.invalid) {
                                <mat-error>{{ 'dottnet.extra.payment.name' | translate }} {{ 'dottnet.field.error.required' | translate }}
                                </mat-error>
                                }
                                <div class="flex-row pay-field">
                                    <label for="email" data-tid="elements_examples.form.email_label">{{ 'dottnet.extra.payment.email' |
                    translate }}*</label>
                                    <input id="email" data-tid="elements_examples.form.email_placeholder" type="email" required [formControl]="email" autocomplete="email" />
                                </div>
                                @if (email.invalid) {
                                <mat-error>{{ 'dottnet.extra.payment.email' | translate }} {{ 'dottnet.field.error.required' | translate }}
                                </mat-error>
                                }
                            </fieldset>
                            <fieldset>
                                <div class="form-row pay-field">
                                    <div id="card-element"></div>
                                    <div id="card-errors" role="alert"></div>
                                </div>
                            </fieldset>
                            <div class="flex-row flex-justify-center extra-prosegui-button">
                                @if (isProcess) {
                                <button type="submit" class="btn btn-primary btn-lg btn-oro" id="submit" mat-button>
                  {{ 'dottnet.extra.payment.processing' | translate }}
                </button> }
                            </div>
                            <div class="flex-row flex-justify-center extra-prosegui-button">
                                @if (isPagare) {
                                <button [disabled]="email.invalid || name.invalid" type="submit" class="btn btn-primary btn-lg btn-oro" id="submit" mat-button>
                  {{ 'dottnet.extra.paga' | translate }}
                </button> }
                            </div>
                        </form>
                    </mat-tab>
                    <mat-tab label="Bonifico">
                        <h4>{{ 'dottnet.extra.coming' | translate }}</h4>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
    }
</div>
}
